import { formatMessage } from '@/utils/i18n';
import React from 'react';

type Props = {
  i18nBasePath: string;
  isDisabled: boolean;
  nbSelectedAccounts: number;
  onImportAccounts: () => void;
};

export const ImportAccountsFooter = ({ onImportAccounts, isDisabled, i18nBasePath, nbSelectedAccounts }: Props) => (
  <button className="primary-v2 primary button" onClick={onImportAccounts} disabled={isDisabled}>
    {formatMessage(`${i18nBasePath}.ImportButton`, { nbSelectedAccounts })}
  </button>
);
